// extracted by mini-css-extract-plugin
export var content = "_cn-3";
export var list = "_cn-4";
export var settingsContent = "_cn-7";
export var settingsPanel = "_cn-8";
export var state = "_cn-6";
export var triggerBadge = "_cn-2";
export var triggerButton = "_cn-1";
export var triggerShell = "_cn-0";
export var unreadDot = "_cn-5";